import { Kind } from "../schema/types/base";

export const kindMetadata = {
  account: {
    kind: "account",
    name: "Account",
    pluralName: "Accounts",
    indefiniteArticle: "an",
  },
  agent: {
    kind: "agent",
    name: "Agent",
    pluralName: "Agents",
    indefiniteArticle: "an",
  },
  auditctx: {
    kind: "auditctx",
    name: "Audit Context",
    pluralName: "Audit Contexts",
    indefiniteArticle: "an",
  },
  cloudaccount: {
    kind: "cloudaccount",
    name: "Cloud Account",
    pluralName: "Cloud Accounts",
    indefiniteArticle: "a",
  },
  domain: {
    kind: "domain",
    name: "Domain",
    pluralName: "Domains",
    indefiniteArticle: "a",
  },
  group: {
    kind: "group",
    name: "Group",
    pluralName: "Groups",
    indefiniteArticle: "a",
  },
  gvc: {
    kind: "gvc",
    name: "GVC",
    pluralName: "GVCs",
    indefiniteArticle: "a",
  },
  identity: {
    kind: "identity",
    name: "Identity",
    pluralName: "Identities",
    indefiniteArticle: "an",
  },
  image: {
    kind: "image",
    name: "Image",
    pluralName: "Images",
    indefiniteArticle: "an",
  },
  ipset: {
    kind: "ipset",
    name: "IP Set",
    pluralName: "IP Sets",
    indefiniteArticle: "an",
  },
  location: {
    kind: "location",
    name: "Location",
    pluralName: "Locations",
    indefiniteArticle: "a",
  },
  mk8s: {
    kind: "mk8s",
    name: "Kubernetes",
    pluralName: "Kubernetes",
    indefiniteArticle: "a",
  },
  org: {
    kind: "org",
    name: "Org",
    pluralName: "Orgs",
    indefiniteArticle: "an",
  },
  policy: {
    kind: "policy",
    name: "Policy",
    pluralName: "Policies",
    indefiniteArticle: "a",
  },
  quota: {
    kind: "quota",
    name: "Quota",
    pluralName: "Quotas",
    indefiniteArticle: "a",
  },
  secret: {
    kind: "secret",
    name: "Secret",
    pluralName: "Secrets",
    indefiniteArticle: "a",
  },
  serviceaccount: {
    kind: "serviceaccount",
    name: "Service Account",
    pluralName: "Service Accounts",
    indefiniteArticle: "a",
  },
  // TODO need an icon for this
  task: {
    kind: "task",
    name: "Task",
    pluralName: "Tasks",
    indefiniteArticle: "a",
  },
  user: {
    kind: "user",
    name: "User",
    pluralName: "Users",
    indefiniteArticle: "a",
  },
  volumeset: {
    kind: "volumeset",
    name: "Volume Set",
    pluralName: "Volume Sets",
    indefiniteArticle: "a",
  },
  workload: {
    kind: "workoad",
    name: "Workload",
    pluralName: "Workloads",
    indefiniteArticle: "a",
  },
};

export const allKinds: Kind[] = Object.keys(kindMetadata) as Kind[];
